<template>
  <div class="smrz-page">
    <div class="smrz-page__container">
      <h1 class="smrz-page__title">实名认证</h1>
      <p class="smrz-page__subtitle">完成实名认证后，您将获得更多专属权益</p>
      
      <div class="smrz-page__card">
        <div class="smrz-page__card-header">
          <div class="smrz-page__status" :class="{ 'smrz-page__status--verified': isVerified }">
            <div class="smrz-page__status-icon">
              <svg v-if="!isVerified" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <span>{{ isVerified ? '审核中...' : '未认证' }}</span>
          </div>
        </div>
        
        <div class="smrz-page__card-body">
          <div v-if="!isVerified">
            <div class="smrz-page__tips">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <span>实名认证是用户使用平台服务的必要条件，认证信息将严格保密，仅用于身份核验。</span>
            </div>
            
            <form class="smrz-page__form" @submit.prevent="submitVerification" autocomplete="off">
              <div class="smrz-page__form-group">
                <label class="smrz-page__form-label">真实姓名 <span class="smrz-page__required">*</span></label>
                <input type="text" class="smrz-page__form-input" v-model="form.realName" placeholder="请输入您的真实姓名" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" />
                <div class="smrz-page__form-hint">请与身份证上的姓名一致</div>
              </div>
              
              <div class="smrz-page__form-group">
                <label class="smrz-page__form-label">身份证号码 <span class="smrz-page__required">*</span></label>
                <input type="text" class="smrz-page__form-input" v-model="form.idCard" placeholder="请输入18位身份证号码" maxlength="18" autocomplete="off" />
                <div class="smrz-page__form-hint">我们将严格保密您的身份证信息</div>
              </div>
              
              <div class="smrz-page__form-group">
                <label class="smrz-page__form-label">性别 <span class="smrz-page__required">*</span></label>
                <div class="smrz-page__form-radio-group">
                  <label class="smrz-page__form-radio-label">
                    <input type="radio" name="gender" value="male" v-model="form.gender" />
                    <span>男</span>
                  </label>
                  <label class="smrz-page__form-radio-label">
                    <input type="radio" name="gender" value="female" v-model="form.gender" />
                    <span>女</span>
                  </label>
                </div>
              </div>
              
              <div class="smrz-page__form-group">
                <label class="smrz-page__form-label">出生日期 <span class="smrz-page__required">*</span></label>
                <input type="date" class="smrz-page__form-input" v-model="form.birthDate" autocomplete="off" />
              </div>
              
              <div class="smrz-page__form-group smrz-page__form-group--upload">
                <label class="smrz-page__form-label">身份证正面照片 <span class="smrz-page__required">*</span></label>
                <div class="smrz-page__upload-area" @click="selectImage('idCardFront')">
                  <div v-if="form.idCardFront" class="smrz-page__upload-preview">
                    <img :src="form.idCardFront" alt="身份证正面" />
                  </div>
                  <div v-else class="smrz-page__upload-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                    <span>点击上传身份证正面</span>
                  </div>
                </div>
                <input type="file" ref="idCardFrontInput" class="smrz-page__upload-input" accept="image/*" @change="handleImageChange($event, 'idCardFront')" />
                <div class="smrz-page__form-hint">请上传清晰的身份证正面照片，支持 JPG/PNG 格式，大小不超过 5MB</div>
              </div>
              
              <div class="smrz-page__form-group smrz-page__form-group--upload">
                <label class="smrz-page__form-label">身份证反面照片 <span class="smrz-page__required">*</span></label>
                <div class="smrz-page__upload-area" @click="selectImage('idCardBack')">
                  <div v-if="form.idCardBack" class="smrz-page__upload-preview">
                    <img :src="form.idCardBack" alt="身份证反面" />
                  </div>
                  <div v-else class="smrz-page__upload-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                    <span>点击上传身份证反面</span>
                  </div>
                </div>
                <input type="file" ref="idCardBackInput" class="smrz-page__upload-input" accept="image/*" @change="handleImageChange($event, 'idCardBack')" />
                <div class="smrz-page__form-hint">请上传清晰的身份证反面照片，支持 JPG/PNG 格式，大小不超过 5MB</div>
              </div>
              
              <div class="smrz-page__form-group smrz-page__form-group--upload">
                <label class="smrz-page__form-label">手持身份证照片 <span class="smrz-page__required">*</span></label>
                <div class="smrz-page__upload-area" @click="selectImage('holdingCard')">
                  <div v-if="form.holdingCard" class="smrz-page__upload-preview">
                    <img :src="form.holdingCard" alt="手持身份证" />
                  </div>
                  <div v-else class="smrz-page__upload-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                    <span>点击上传手持身份证照片</span>
                  </div>
                </div>
                <input type="file" ref="holdingCardInput" class="smrz-page__upload-input" accept="image/*" @change="handleImageChange($event, 'holdingCard')" />
                <div class="smrz-page__form-hint">请手持身份证拍照，确保面部清晰可见，身份证信息完整</div>
              </div>
              
              <div class="smrz-page__form-group">
                <label class="smrz-page__form-label">联系地址</label>
                <input type="text" class="smrz-page__form-input" v-model="form.address" placeholder="请输入联系地址（选填）" autocomplete="off" />
              </div>
              
              <div class="smrz-page__form-group smrz-page__form-group--checkbox">
                <input type="checkbox" id="agree-terms" class="smrz-page__form-checkbox" v-model="form.agreeTerms" />
                <label for="agree-terms" class="smrz-page__form-checkbox-label">
                  我已阅读并同意<router-link to="/yhys?tab=agreement" class="smrz-page__form-link">《用户协议》</router-link>和<router-link to="/yhys?tab=privacy" class="smrz-page__form-link">《隐私政策》</router-link>，并授权平台进行身份核验。
                </label>
              </div>
              
              <button type="submit" class="smrz-page__submit-btn" :disabled="isSubmitting">
                <span v-if="!isSubmitting">提交认证</span>
                <span v-else class="smrz-page__submit-btn-loading">
                  提交中...
                </span>
              </button>
            </form>
          </div>
          
          <div v-else class="smrz-page__verified-content">
            <div class="smrz-page__verified-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h3 class="smrz-page__verified-title">实名认证审核中</h3>
            <p class="smrz-page__verified-desc">您的实名认证已成功提交，正在审核中。</p>
            
            <div class="smrz-page__verified-info">
              <div class="smrz-page__verified-item">
                <span class="smrz-page__verified-label">姓名</span>
                <span class="smrz-page__verified-value">{{ form.realName || '***' }}</span>
              </div>
              <div class="smrz-page__verified-item">
                <span class="smrz-page__verified-label">身份证</span>
                <span class="smrz-page__verified-value">{{ form.idCard ? form.idCard.replace(/(\d{4})\d{10}(\d{4})/, '$1**********$2') : '***' }}</span>
              </div>
              <div class="smrz-page__verified-item">
                <span class="smrz-page__verified-label">认证时间</span>
                <span class="smrz-page__verified-value">{{ verifyTime }}</span>
              </div>
            </div>
            
            <div class="smrz-page__verified-benefits">
              <h4 class="smrz-page__verified-benefits-title">认证后可享受的权益</h4>
              <ul class="smrz-page__verified-benefits-list">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <span>上传原创音乐作品</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <span>开通会员专属服务</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <span>参与平台活动</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                  <span>获得专属客服支持</span>
                </li>
              </ul>
            </div>
            
            <button class="smrz-page__submit-btn smrz-page__submit-btn--secondary" @click="reapply">重新认证</button>
          </div>
        </div>
      </div>
      
      <div class="smrz-page__faq">
        <h3 class="smrz-page__faq-title">常见问题</h3>
        <div class="smrz-page__faq-item" v-for="(faq, index) in faqs" :key="index">
          <div class="smrz-page__faq-question" @click="toggleFaq(index)">
            <span class="smrz-page__faq-arrow">{{ faq.open ? '−' : '+' }}</span>
            {{ faq.question }}
          </div>
          <div class="smrz-page__faq-answer" v-if="faq.open">{{ faq.answer }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Smrz',
  data() {
    return {
      isVerified: false,
      isSubmitting: false,
      verifyTime: '',
      form: {
        realName: '',
        idCard: '',
        gender: '',
        birthDate: '1999-05-06',
        idCardFront: '',
        idCardBack: '',
        holdingCard: '',
        address: '',
        agreeTerms: false
      },
      faqs: [
        {
          question: '为什么需要实名认证？',
          answer: '实名认证是保障平台安全运营的重要措施，根据相关法律法规要求，平台需要对用户身份进行核验。完成认证后，您可以享受上传音乐、开通会员等更多服务。',
          open: false
        },
        {
          question: '我的个人信息会被泄露吗？',
          answer: '绝对不会。您的实名认证信息将严格保密，仅用于身份核验，不会用于其他用途，也不会泄露给任何第三方。我们采用加密存储技术，确保您的信息安全。',
          open: false
        },
        {
          question: '身份证照片有什么要求？',
          answer: '请确保照片清晰完整，身份证上的文字和照片清晰可见，无遮挡、无反光、无模糊。建议在光线充足的环境下拍摄，避免使用美颜滤镜。',
          open: false
        },
        {
          question: '实名认证需要多长时间？',
          answer: '一般情况下，我们会在1-3个工作日内完成审核。审核结果将通过短信通知您，请保持手机畅通。',
          open: false
        },
        {
          question: '实名认证失败怎么办？',
          answer: '如果实名认证失败，我们会通过短信告知您失败原因。您可以根据提示修改信息后重新提交认证申请。',
          open: false
        }
      ]
    }
  },
  methods: {
    selectImage(field) {
      this.$refs[field + 'Input'].click();
    },
    handleImageChange(e, field) {
      const file = e.target.files[0];
      if (!file) return;
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        alert('请上传 JPG 或 PNG 格式的图片');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('图片大小不能超过 5MB');
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        this.form[field] = event.target.result;
      };
      reader.readAsDataURL(file);
    },
    toggleFaq(index) {
      this.faqs[index].open = !this.faqs[index].open;
    },
    submitVerification() {
      const isLoggedIn = !!localStorage.getItem('YousrDL')
      if (!isLoggedIn) {
        alert('您还没有登录');
        return;
      }

      if (!this.form.realName) {
        alert('请输入真实姓名');
        return;
      }
      if (!this.form.idCard) {
        alert('请输入身份证号码');
        return;
      }
      if (!/^\d{17}[\dXx]$/.test(this.form.idCard)) {
        alert('请输入正确的18位身份证号码');
        return;
      }
      if (!this.form.gender) {
        alert('请选择性别');
        return;
      }
      if (!this.form.birthDate) {
        alert('请选择出生日期');
        return;
      }
      if (!this.form.idCardFront) {
        alert('请上传身份证正面照片');
        return;
      }
      if (!this.form.idCardBack) {
        alert('请上传身份证反面照片');
        return;
      }
      if (!this.form.holdingCard) {
        alert('请上传手持身份证照片');
        return;
      }
      if (!this.form.agreeTerms) {
        alert('请阅读并同意用户协议和隐私政策');
        return;
      }
      
      this.isSubmitting = true;
      // 记录提交时间
      const now = new Date();
      this.verifyTime = now.getFullYear() + '-' + 
        String(now.getMonth() + 1).padStart(2, '0') + '-' + 
        String(now.getDate()).padStart(2, '0') + ' ' + 
        String(now.getHours()).padStart(2, '0') + ':' + 
        String(now.getMinutes()).padStart(2, '0') + ':' + 
        String(now.getSeconds()).padStart(2, '0');
      
      setTimeout(() => {
        this.isSubmitting = false;
        this.isVerified = true;
        // 认证成功后滚动到页面顶部
        window.scrollTo({ top: 0, behavior: 'smooth' });
        alert('实名认证提交成功！我们将在1-3个工作日内完成审核。');
      }, 2000);
    },
    reapply() {
      this.isVerified = false;
      this.form = {
        realName: '',
        idCard: '',
        gender: '',
        birthDate: '1999-05-03',
        idCardFront: '',
        idCardBack: '',
        holdingCard: '',
        address: '',
        agreeTerms: false
      };
    }
  }
}
</script>

<style scoped lang="scss">
.smrz-page {
  width: 100%;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  padding: 40px 20px;
  box-sizing: border-box;
  background-image: url('../../assets/gryh.jpg');
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
}

.smrz-page__container {
  max-width: 600px;
  margin: 0 auto;
}

.smrz-page__title {
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin: 0 0 10px 0;
  letter-spacing: 1px;
}

.smrz-page__subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin: 0 0 30px 0;
}

.smrz-page__card {
  background-color: rgba(107, 42, 42, 0.95);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.smrz-page__card-header {
  background-color: rgba(243, 112, 33, 0.2);
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.smrz-page__status {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  
  &--verified {
    color: #f37021;
  }
}

.smrz-page__status-icon {
  svg {
    width: 20px;
    height: 20px;
  }
}

.smrz-page__card-body {
  padding: 24px;
}

.smrz-page__tips {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 15px;
  background-color: rgba(243, 112, 33, 0.1);
  border-radius: 8px;
  margin-bottom: 20px;
  
  svg {
    width: 18px;
    height: 18px;
    color: #f37021;
    flex-shrink: 0;
    margin-top: 2px;
  }
  
  span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.5;
  }
}

.smrz-page__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.smrz-page__form-group {
  display: flex;
  flex-direction: column;
  
  &--upload {
    margin-top: 8px;
  }
  
  &--checkbox {
    flex-direction: row;
    align-items: flex-start;
    gap: 10px;
    margin-top: 8px;
  }
}

.smrz-page__form-label {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 6px;
}

.smrz-page__required {
  color: #f37021;
}

.smrz-page__form-input {
  height: 44px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #ffffff;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
  transition: all 0.2s;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
  
  &:focus {
    background-color: rgba(0, 0, 0, 0.4);
  }
  
  &--short {
    flex: 1;
  }
}

.smrz-page__form-row {
  display: flex;
  gap: 12px;
}

.smrz-page__form-btn {
  padding: 0 20px;
  height: 44px;
  border: none;
  border-radius: 6px;
  background-color: #f37021;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  
  &:hover:not(:disabled) {
    background-color: #d95e12;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.smrz-page__form-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 4px;
}

.smrz-page__form-radio-group {
  display: flex;
  gap: 24px;
}

.smrz-page__form-radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  
  input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #f37021;
  }
}

.smrz-page__form-checkbox {
  width: 16px;
  height: 16px;
  accent-color: #f37021;
  flex-shrink: 0;
  margin-top: 2px;
}

.smrz-page__form-checkbox-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
}

.smrz-page__form-link {
  color: #f37021;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
}

.smrz-page__upload-area {
  width: 100%;
  height: 120px;
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.2s;
  
  &:hover {
    border-color: #f37021;
    background-color: rgba(243, 112, 33, 0.1);
  }
}

.smrz-page__upload-preview {
  width: 100%;
  height: 100%;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.smrz-page__upload-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  svg {
    width: 32px;
    height: 32px;
    color: rgba(255, 255, 255, 0.4);
  }
  
  span {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
  }
}

.smrz-page__upload-input {
  display: none;
}

.smrz-page__submit-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 6px;
  background-color: #f37021;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  
  &:hover:not(:disabled) {
    background-color: #d95e12;
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  &--secondary {
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.25);
    }
  }
}

.smrz-page__submit-btn-loading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.smrz-page__loading-circle {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.smrz-page__verified-content {
  text-align: center;
}

.smrz-page__verified-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  background-color: rgba(243, 112, 33, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 40px;
    height: 40px;
    color: #f37021;
  }
}

.smrz-page__verified-title {
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px 0;
}

.smrz-page__verified-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 24px 0;
}

.smrz-page__verified-info {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.smrz-page__verified-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  
  &:last-child {
    border-bottom: none;
  }
}

.smrz-page__verified-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.smrz-page__verified-value {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
}

.smrz-page__verified-benefits {
  margin-bottom: 24px;
}

.smrz-page__verified-benefits-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 12px 0;
}

.smrz-page__verified-benefits-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.smrz-page__verified-benefits-list li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  padding: 10px 12px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  
  svg {
    width: 16px;
    height: 16px;
    color: #f37021;
    flex-shrink: 0;
  }
}

.smrz-page__faq {
  margin-top: 24px;
  background-color: rgba(107, 42, 42, 0.8);
  border-radius: 8px;
  overflow: hidden;
}

.smrz-page__faq-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  padding: 16px 20px;
  margin: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.smrz-page__faq-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  
  &:last-child {
    border-bottom: none;
  }
}

.smrz-page__faq-question {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  transition: all 0.2s;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.smrz-page__faq-arrow {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f37021;
  font-size: 16px;
  font-weight: bold;
}

.smrz-page__faq-answer {
  padding: 0 20px 14px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .smrz-page {
    padding: 20px 15px;
  }
  
  .smrz-page__title {
    font-size: 24px;
  }
  
  .smrz-page__subtitle {
    font-size: 14px;
  }
  
  .smrz-page__card-body {
    padding: 16px;
  }
  
  .smrz-page__form-row {
    flex-direction: column;
  }
  
  .smrz-page__form-btn {
    width: 100%;
  }
  
  .smrz-page__verified-benefits-list {
    grid-template-columns: 1fr;
  }
  
  .smrz-page__faq-title {
    font-size: 14px;
  }
}
</style>